export class ModalRef {
    constructor(componentRef, _modalContentComponentRef, options, priority = 1) {
        this.componentRef = componentRef;
        this._modalContentComponentRef = _modalContentComponentRef;
        this.options = options;
        this.priority = priority;
        this.configureModal(options);
        this.close();
    }
    get modalContent() {
        return this._modalContentComponentRef.instance;
    }
    close() {
        this.componentRef.instance.isOpen = false;
        this.componentRef.changeDetectorRef.detectChanges();
    }
    configureModal(options) {
        const modalInstance = this.componentRef.instance;
        if (options) {
            Object.keys(options).forEach((config) => (modalInstance[config] = options[config]));
        }
    }
}
